<script>
	import { Html, LayerCake, Svg } from "layercake";

	import Line from "./Line.svelte";
	import Area from "./Area.svelte";
	import AxisX from "./AxisX.svelte";
	import Highlight from "./Highlight.svelte";

	import { formatFloat, formatInt } from "../map/language";

	const years = [2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022];

	export let data;
	export let colorScale;

	$: formattedData = data
		? years
				.map((year) => {
					const value = data[year];
					if (value) {
						return { year, value: (100 * value) / data[2015] - 100 };
					}
				})
				.filter((d) => !!d)
		: [];

	const frmt = formatFloat({ signed: true, postfix: "%" });
</script>

<div class="chart-container">
	<LayerCake padding={{ top: 0, right: 10, bottom: 0, left: 10 }} x="year" y="value" data={formattedData}>
		<Svg>
			<Area {colorScale} />
			<AxisX ticks={years} baseline={true} />
			<Line stroke={"#AAAAAA"} strokeWidth={4} />
		</Svg>
		<Html>
			<Highlight year={2015} label="" color={colorScale(0)} />
			<Highlight year={2022} format={frmt} color={colorScale(data.change)} />
		</Html>
	</LayerCake>
</div>

<style>
	.chart-container {
		width: 100%;
		height: 70px;
		margin-bottom: 15px;
	}
</style>
